export default __webpack_public_path__ + "static/media/icosahedron.ef6a9c11.jpg";